import { dispatchProps } from '@/entity';
export default {
  namespace: 'order', // 表示在全局 state 上的 key
  state: { tab: 0, userCenter: '' }, // 状态数据
  // 管理同步方法，必须是纯函数
  reducers: {
    setTab(state, { payload }: dispatchProps) {
      return {
        ...state,
        tab:payload
      };
    },

    setUserCenter(state, { payload }: dispatchProps) {
      return {
        ...state,
        userCenter: payload
      };
    }
  },

  effects: {

  },
  subscriptions: {} // 订阅数据源
};
